<script setup lang="ts">
import { useColorMode } from "@vueuse/core";
import { watchEffect } from "vue";

import MasterLayout from "@/layouts/MasterLayout.vue";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { system, store, state } = useColorMode();

// the app's dark mode is the `dark` class on <html>; @app/core components (tags, cards, tables)
// read `data-theme` instead, so it follows the same resolved mode
watchEffect(() => {
  document.documentElement.setAttribute("data-theme", state.value === "dark" ? "dark" : "light");
});
</script>

<template>
  <MasterLayout />
</template>
